import React from 'react';
import SiteFooter from './common/SiteFooter';
import { useNavigate } from 'react-router-dom';
import { LogIn, UserPlus, ArrowRight } from 'lucide-react';

// 비로그인 첫 화면 — 풀스크린 성단(star cluster) 배경 + 텍스트 메뉴 3개
// 목록은 자유롭게 보고, 상세/작성은 각 페이지에서 로그인 게이트
function PublicHome() {
    const navigate = useNavigate();

    const menus = [
        { no: '01', title: '제작의뢰', desc: '거래처 지정 없이 올라온 의뢰를 확인하세요', path: '/requests' },
        { no: '02', title: '기공소 찾기', desc: '홍보를 오픈한 전국 기공소를 둘러보세요', path: '/find-lab' },
        { no: '03', title: '보철 갤러리', desc: '기공소가 직접 올린 실제 작업물', path: '/gallery' },
    ];

    return (
        <>
        <div style={S.container}>
            {/* 배경 — NASA 허블 성단 사진 (퍼블릭 도메인), 로드 전에는 그라데이션 */}
            <img src="/images/space_bg.jpg" alt="" style={S.bgImage} />
            <div style={S.bgOverlay} />

            {/* 상단 바 */}
            <header style={S.topBar}>
                <div style={S.logo}>
                    <img src="/cluster-icon.png" alt="DentalCluster" style={S.logoImg} />
                    DentalCluster
                </div>
                <div style={S.topBtns}>
                    <button style={S.loginBtn} onClick={() => navigate('/login')}>
                        <LogIn size={15} /> 로그인
                    </button>
                    <button style={S.signupBtn} onClick={() => navigate('/signup')}>
                        <UserPlus size={15} /> 무료 회원가입
                    </button>
                </div>
            </header>

            {/* 본문 */}
            <main style={S.main}>
                <div style={S.left}>
                    <div style={S.purposeBadges}>
                        <span style={S.badge}>국내 — 기공소 연결</span>
                        <span style={S.badge}>해외 — 디자인 연결</span>
                    </div>
                    <h1 style={S.title}>
                        치과와 기공을 잇다,<br />덴탈클러스터
                    </h1>
                    <p style={S.subtitle}>
                        국내 치과는 기공소와, 해외 치과는 국내 디자인과 연결됩니다.<br />
                        의뢰서 작성부터 제작·납품·거래명세서까지 한 곳에서.
                    </p>
                </div>

                <nav style={S.menuList}>
                    {menus.map(m => (
                        <button key={m.no} className="ph-menu" style={S.menuItem} onClick={() => navigate(m.path)}>
                            <span style={S.menuNo}>{m.no}</span>
                            <span style={S.menuBody}>
                                <span className="ph-menu-title" style={S.menuTitle}>{m.title}</span>
                                <span style={S.menuDesc}>{m.desc}</span>
                            </span>
                            <ArrowRight className="ph-menu-arrow" size={26} style={S.menuArrow} />
                        </button>
                    ))}
                </nav>
            </main>

            <footer style={S.footer}>
                <span>둘러보기는 자유 · 상세보기와 의뢰서 작성은 로그인 후 가능합니다</span>
            </footer>

            <style>{`
                .ph-menu { transition: transform 0.2s ease, background-color 0.2s ease; }
                .ph-menu:hover { transform: translateX(10px); background-color: rgba(255,255,255,0.08) !important; }
                .ph-menu:hover .ph-menu-title { color: #93c5fd; }
                .ph-menu:hover .ph-menu-arrow { opacity: 1; transform: translateX(0); }
                .ph-menu-title { transition: color 0.2s ease; }
                .ph-menu-arrow { transition: opacity 0.2s ease, transform 0.2s ease; }
            `}</style>
        </div>
        {/* 사업자정보 푸터 — 히어로(100vh·overflow hidden) 밖으로 이동(2026-09-23): 안쪽에 있으면 화면에 안 보였음(토스 심사 캡처 중 발견) */}
        <SiteFooter />
        </>
    );
}

const S = {
    container: {
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 55%, #2563eb 100%)',
        overflow: 'hidden',
    },
    bgImage: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 },
    bgOverlay: {
        position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
        background: 'linear-gradient(90deg, rgba(2,6,23,0.82) 0%, rgba(2,6,23,0.6) 55%, rgba(2,6,23,0.45) 100%)',
        zIndex: 1,
    },

    topBar: {
        position: 'relative', zIndex: 2,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '22px clamp(20px, 5vw, 56px)',
    },
    logo: { fontSize: 20, fontWeight: 800, color: '#fff', letterSpacing: '-0.02em', display: 'flex', alignItems: 'center', gap: 10 },
    logoImg: { width: 32, height: 32, borderRadius: 9, boxShadow: '0 2px 10px rgba(0,0,0,0.35)' },
    topBtns: { display: 'flex', gap: 10, alignItems: 'center' },
    loginBtn: {
        display: 'flex', alignItems: 'center', gap: 6,
        padding: '10px 16px', background: 'none', border: 'none',
        color: 'rgba(255,255,255,0.85)', fontSize: 14, fontWeight: 600, cursor: 'pointer',
    },
    signupBtn: {
        display: 'flex', alignItems: 'center', gap: 6,
        padding: '11px 20px', backgroundColor: '#3b82f6', color: '#fff',
        border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: 'pointer',
        boxShadow: '0 4px 16px rgba(59,130,246,0.4)',
    },

    main: {
        position: 'relative', zIndex: 2, flex: 1,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 'clamp(32px, 6vw, 80px)', flexWrap: 'wrap',
        padding: '40px clamp(20px, 5vw, 56px)',
        maxWidth: 1280, width: '100%', margin: '0 auto', boxSizing: 'border-box',
    },
    left: { flex: '1 1 400px', minWidth: 300 },
    purposeBadges: { display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 24 },
    badge: {
        padding: '8px 16px', borderRadius: 999,
        backgroundColor: 'rgba(59,130,246,0.18)', border: '1px solid rgba(147,197,253,0.4)',
        color: '#bfdbfe', fontSize: 13, fontWeight: 700,
    },
    title: {
        margin: '0 0 20px', fontSize: 'clamp(32px, 4.5vw, 52px)', fontWeight: 800,
        lineHeight: 1.25, color: '#fff', textShadow: '0 2px 16px rgba(0,0,0,0.4)',
    },
    subtitle: {
        margin: 0, fontSize: 'clamp(15px, 1.6vw, 17px)', lineHeight: 1.8,
        color: 'rgba(255,255,255,0.85)', textShadow: '0 1px 8px rgba(0,0,0,0.4)',
    },

    menuList: {
        flex: '1 1 420px', minWidth: 300, maxWidth: 560,
        display: 'flex', flexDirection: 'column', gap: 10,
    },
    menuItem: {
        display: 'flex', alignItems: 'center', gap: 20,
        padding: '24px 26px', textAlign: 'left',
        backgroundColor: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.14)', borderRadius: 18,
        cursor: 'pointer', backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
    },
    menuNo: { fontSize: 14, fontWeight: 700, color: 'rgba(147,197,253,0.8)', letterSpacing: '0.1em' },
    menuBody: { flex: 1, display: 'flex', flexDirection: 'column', gap: 5 },
    menuTitle: { fontSize: 'clamp(22px, 2.6vw, 30px)', fontWeight: 800, color: '#fff', lineHeight: 1.2 },
    menuDesc: { fontSize: 13.5, color: 'rgba(255,255,255,0.6)' },
    menuArrow: { color: '#93c5fd', opacity: 0.35, transform: 'translateX(-6px)', flexShrink: 0 },

    footer: {
        position: 'relative', zIndex: 2, textAlign: 'center',
        padding: '20px', fontSize: 13, color: 'rgba(255,255,255,0.5)',
    },
};

export default PublicHome;
